module.exports = __webpack_public_path__ + "media/images/homes/SetPermissionsandRoles-f06cda117a7fd2bb7d5b5c6f82cd9948.png";